/* global axios */
import ApiClient from './ApiClient';

class AdsConnectionsAPI extends ApiClient {
  constructor() {
    super('integrations/ads_connections', { accountScoped: true });
  }

  show(provider) {
    return axios.get(`${this.url}/${provider}`);
  }

  authorize(provider) {
    return axios.post(`${this.url}/${provider}/authorization`);
  }

  listOptions(provider) {
    return axios.get(`${this.url}/${provider}/options`);
  }

  select(provider, optionId) {
    return axios.patch(`${this.url}/${provider}`, { option_id: optionId });
  }

  disconnect(provider) {
    return axios.delete(`${this.url}/${provider}`);
  }
}

export default new AdsConnectionsAPI();
